import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store/index";
import * as FamilyServiceActions from "../../store/familyService/actions";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds } from "../../config/UserServicesList";
import { DialogComponent } from "../common/DialogComponent";
import FamilyProtectionDialog from "../Dialogs/FamilyProtectionDialog";
import { useTranslation } from "react-i18next";

const FamilyProtectionServiceFPS = (props: any) => {
    const [isFamilyProtectionDialogVisible, setFamilyProtectionDialogIsVisible] = useState(false);
    const dispatch = useDispatch();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const getFPSFamilySubscribers = () => dispatch(FamilyServiceActions.actionCreators.getFPSFamilySubscribers());
    const isFamilyProtectionServiceActive = useAreServicesActive([ezsServiceIds.familyProtectionService]);
    const eZSChildSubscribers = useSelector((state: ApplicationState) =>
        state.familyServiceState && state.familyServiceState.eZSChildSubscribers ? state.familyServiceState.eZSChildSubscribers : []
    );

    const openAddFamilyProtectionDialog = (): any => {
        setFamilyProtectionDialogIsVisible(true);
    };

    const closeFamilyProtectionDialog = (): any => {
        setFamilyProtectionDialogIsVisible(false);
    };

    useEffect(() => {
        getFPSFamilySubscribers();
    }, []);

    return (
        <React.Fragment>
            {eZSChildSubscribers && eZSChildSubscribers.length > 0 && isFamilyProtectionServiceActive && (
                <div className="account-area-list">
                    <h4 className="section_title">{tLang("dashboard.userMenuDropdown.familyProtection")}</h4>
                    <ul role="menu" className="submenu-texts">
                        {eZSChildSubscribers.map((member) => {
                            return (
                                <li key={member.id} role="presentation">
                                    <a role="menuitem">
                                        <em className={"las la-lock"}></em>
                                        <span className="sr-only">Family Member Name</span>
                                        {` ${member.firstName} ${member.lastName}`}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}

            {eZSChildSubscribers.length <= 0 && (
                <div className="account-area-add">
                    <a href="javascript:void(0);" onClick={openAddFamilyProtectionDialog} className="default_link">
                        <em className="las la-plus"></em> {tLang("dashboard.userMenuDropdown.addFamilyMember")}
                    </a>
                </div>
            )}

            {isFamilyProtectionDialogVisible && (
                <DialogComponent dialogId="dialog-add-family-member-account-dialog" title="Add Family Member" closeDialog={closeFamilyProtectionDialog}>
                    <FamilyProtectionDialog closeDialog={closeFamilyProtectionDialog} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default FamilyProtectionServiceFPS;
